import { Informations } from "./bilgiler";
import { commerceFetchForOptionalSession } from "./commerce-api";

export const getInformations = async (): Promise<Informations[]> => {
  const response = await commerceFetchForOptionalSession(`/settings/informations-public/`);
  return response;
};
